export default "__VITE_ASSET__D5AuckEN__"